import React, { useState } from "react";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as url from "../../../utils/url";
import axios from "../../../axios";
import { toastContainer } from "../../../utils/toast";
import { withRouter } from "react-router-dom";
import withLoading from "../../../hoc/Loading/Loading";

function UpgradeModal({ open, onClose, userDetails, ...props }) {
  const [step, setStep] = useState(1);
  const [loading,setLoading] = useState(false)
  const handleUpgrade = () => {
    setLoading(true)
    axios
      .post(url.handleUserOrgUpgrate, userDetails)
      .then(({ data }) => {
        toastContainer(
          <div>
            You have succesfully upgraded your account,{" "}
            <b
              className="cursor-pointer"
              onClick={() => {
                props.history.push("/login")
              }}
            >
              Click here
            </b>{" "}
            to login to your account.
          </div>,
          "success"
        );
      })
      .catch((error) => {
        setLoading(false)
          let message = "Internal server error"
        if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message 
          ) {
            message = error.response.data.errors.message
          }
          toastContainer(message, "error");
      });
  };
  return (
    <div>
      <Modal isOpen={open}>
        <ModalHeader toggle={onClose}>Upgrade</ModalHeader>
        <ModalBody>
          <Alert>
            Hi <b>{userDetails.email}</b>, Click on continue to upgrade you
            account to use all Workplace Assessment features for your company:{" "}
            <b>{userDetails.companyName}</b>
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => loading ? null : handleUpgrade()}>Continue</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default withRouter(withLoading(UpgradeModal,axios));
